import React from "react";
import "./tagCloud.scss";

const tagLinks = [
	{ href: "https://app.nfd.gg/reviews/retrodrops/6752daa252ad4030b2863e08", label: "Avantis" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/673e40624a6e6421597b262e", label: "Nillion" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/672626f4cf8f640d8ba3d00f", label: "Lombard" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66f54c91903ff7c24de60ca1", label: "Owlto Finance" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66e97f2499803dd8c7d00f75", label: "Eclipse" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66e5f7b5f3a7159a6c7cfc2a", label: "Zoth" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66e034c245493d7675651775", label: "Balance" },
	{ href: "https://app.nfd.gg/reviews/airdrops/66d5bd76c810443e0385a660", label: "Dawn" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66cc47b85f24763755164eb6", label: "Corn" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66cb0b3939cae9bb6dec877d", label: "Reddio" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66c360ee8b36f02fff5a9ed8", label: "Babylon" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66c36dc28b36f02fff5b1f33", label: "B3" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66a3c67a93cd99b272f6ae0f", label: "Farcaster" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66a2239610e5bfcd30f242e5", label: "Monad" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/669e489e1750dad2181313ba", label: "Reya" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/6686b98a4828079486ea60e9", label: "Xterio" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/6638fba5e13f4d767d671dab", label: "Superform" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/66327c881824b91e769d9db2", label: "Hyperlane" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/661fb249d33c4fc4a6366b9e", label: "BOB" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/65f2e269ff14c0db172dd13f", label: "Backpack" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/65e1ca52536df661b14cd8c7", label: "Karak" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/65a6b4bbbcee56195f6bb96a", label: "KiloEx" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/657b4b85412f0a7a42c00ac4", label: "Intract" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/637c84adf8f0628de2776b56", label: "MetaMask" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/64c110cd3b7f85b446f4427c", label: "DeBank" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/64b93016be2b680305cf0db3", label: "Base" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/64b8dbb61468713529d1ec37", label: "Linea" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/64940ac6feb887e10a544e56", label: "Zora" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/648057ed927d57d240be7094", label: "Tabi" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/646d0d4b0b26fcd25c6c7ca7", label: "Boost" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/645e0786c31b13e22420c123", label: "UniSat" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/6426b146157f9bf861a349c7", label: "Zerion" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/642462ee1933ec5e296b04f9", label: "Polynomial Protocol" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/640f42d675aff2b413d2ab16", label: "PhiLand" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/63d11429ca642b4b709e3992", label: "Perennial" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/63c57e9ce7e3fe017fbb27e5", label: "Partybid" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/639c7e6930df7f61ac6a07d5", label: "Bebop" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/639b2eb3bd5ed4cdda66858d", label: "Li.fi" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/6394a0b8ff01ec908cae4670", label: "Socket" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/63889e9405d83fae15abb431", label: "Lens Protocol" },
	{ href: "https://app.nfd.gg/reviews/retrodrops/637f2d6f14d1065bf96dc17b", label: "Orbiter Finance" },
	{ href: "https://app.nfd.gg/reviews/testnets/63f703ea121d119a9f7a13c6", label: "Caldera" },
	{ href: "https://app.nfd.gg/reviews/testnets/6727d5b304b2305ab53bf937", label: "Space and Time" },
	{ href: "https://app.nfd.gg/reviews/testnets/6720d82123255c8c39eccc70", label: "Beyond" },
	{ href: "https://app.nfd.gg/reviews/testnets/671634c6bd20c49e031b076a", label: "Ithaca" },
	{ href: "https://app.nfd.gg/reviews/testnets/67079c54879a680d346a53c6", label: "Hemi Network" },
	{ href: "https://app.nfd.gg/reviews/testnets/66d5f5d1c810443e038712c1", label: "Story Protocol" },
	{ href: "https://app.nfd.gg/reviews/testnets/66d5e22bc810443e0386999e", label: "T3RN" },
	{ href: "https://app.nfd.gg/reviews/testnets/66ce260fc54a4f90ed87fdfe", label: "Chainbase" },
	{ href: "https://app.nfd.gg/reviews/testnets/66856894aee400f609ea573e", label: "Morph" },
	{ href: "https://app.nfd.gg/reviews/testnets/6682a980d69147fa6de1f876", label: "Particle Network" },
	{ href: "https://app.nfd.gg/reviews/testnets/6643ed61b7368a648f834a30", label: "Analog" },
	{ href: "https://app.nfd.gg/reviews/testnets/65b8a13051c426e015ad7e2c", label: "Hana Network" },
	{ href: "https://app.nfd.gg/reviews/testnets/65a07cd4eb644ea8d9dfeef8", label: "Berachain" },
	{ href: "https://app.nfd.gg/reviews/testnets/659b5b2c094d4afcaac34e58", label: "Tea Protocol" },
	{ href: "https://app.nfd.gg/reviews/testnets/651a9e3944044fe35714f415", label: "Fhenix" },

];

const TagCloud = () => {
	const controlButtons = Array.from({ length: 20 }, (_, index) => index + 1);
	
	return (
		<div className="tagCloud">

			<div className="tagCloud-wrapper">
				<div 
					className="tagCloud-controls" 
					style={{ '--num-elements': 20 } as React.CSSProperties}
				>

					{controlButtons.map((index) => (
						<div
							key={index}
							className="tagCloud-control-button"
							style={{ '--index': index } as React.CSSProperties}
						>
							<input type="radio" name="tagCloud-control-input" />
						</div>
					))}

					<div className="tagCloud-rotation">
						<ul className="tagCloud-tags" style={{ '--num-elements': 56 } as React.CSSProperties}>
							{tagLinks.map((tag: any, index: number) => (
								<li
									key={index}
									className="tagCloud-tag"
									style={{
										'--index': index + 1,
										'--_phi': Math.acos(-1 + (2 * (index + 1)) / 56),
										'--_theta': Math.sqrt(56 * 3.141592653589793) * Math.acos(-1 + (2 * (index + 1)) / 56),
									} as React.CSSProperties}
								>
									<div>
										<a href={tag.href} target="_blank">{tag.label}</a>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TagCloud;
